import { ReactNode } from 'react';

import CampaignIcon from '@mui/icons-material/Campaign';

import { TotalizerCard, TotalizerCardShell } from './TotalizerCard';

interface FicFidcAlertsTotalizerProps {
  isLoading: boolean;
  value: ReactNode;
  complement: string;
}

export function FicFidcAlertsTotalizer({
  isLoading,
  value,
  complement,
}: FicFidcAlertsTotalizerProps) {
  return (
    <TotalizerCard
      ariaLabel="Totalizador de alertas do FIC"
      complement={complement}
      complementColor="text.secondary"
      icon={
        <CampaignIcon
          color="error"
          aria-hidden
          data-testid="fic-fidc-alerts-icon"
        />
      }
      isLoading={isLoading}
      label="Alertas do FIC"
      totalizerId="fic-fidc-alerts-totalizer"
      value={value}
      valueColor="error.main"
    />
  );
}

export function FicFidcAlertsCard(props: FicFidcAlertsTotalizerProps) {
  return (
    <TotalizerCardShell accent="error" cardId="fic-fidc-alerts-card">
      <FicFidcAlertsTotalizer {...props} />
    </TotalizerCardShell>
  );
}
